<template>
  <Expandable
    :header="isInternational ? 'Address' : 'Additional Address'"
    class="mb-10"
  >
    <b-row class="pb-0">
      <b-col cols="12" md="4">
        <input-field
          :disabled="isDisabled"
          v-model.trim="form.address_line_1"
          label="Address Line 1"
          rules="max-500"
          @input="input"
        ></input-field>
      </b-col>
      <b-col cols="12" md="4">
        <input-field
          :disabled="isDisabled"
          v-model.trim="form.address_line_2"
          label="Address Line 2"
          rules="max-500"
          @input="input"
        ></input-field>
      </b-col>
      <b-col cols="12" md="4">
        <input-field
          :disabled="isDisabled"
          v-model.trim="form.town_village"
          label="Town Village"
          @input="input"
        ></input-field>
      </b-col>
      <b-col cols="12" md="4">
        <input-field
          :disabled="isDisabled"
          v-model.trim="form.landmark"
          label="Landmark"
          @input="input"
          rules="max-100"
        ></input-field>
      </b-col>
      <b-col cols="12" md="4">
        <autocomplete
          v-model.trim="form.country"
          :disabled="isDisabled"
          @input="onCountryChange"
          label="Country"
          :items="countries"
        ></autocomplete>
      </b-col>
      <b-col cols="12" md="4">
        <autocomplete
          v-model.trim="form.state"
          :disabled="isDisabled"
          label="State"
          @input="onStateChange"
          :items="states"
        ></autocomplete>
      </b-col>
      <b-col cols="12" md="4">
        <autocomplete
          v-model.trim="form.city"
          :disabled="isDisabled"
          :items="citys"
          @input="onCityChange"
          label="City"
        ></autocomplete>
      </b-col>
      <b-col cols="12" md="4" v-if="isKarnataka">
        <autocomplete
          v-model.trim="form.taluk"
          :disabled="isDisabled"
          :items="taluks"
          @input="input"
          label="Taluk"
        ></autocomplete>
      </b-col>
      <b-col cols="12" md="4">
        <input-field
          @input="input"
          :disabled="isDisabled"
          v-model.trim="form.pincode"
          label="Pincode"
          type="number"
          :rules="'zipcode|integer'"
        ></input-field>
      </b-col>
    </b-row>
  </Expandable>
</template>

<script>
import {
  FIELD,
  getMaxNotRules,
  getMaxRules,
  PINCODE,
} from "../../../assets/js/rules";
import { HOSPITAL_TYPES } from "../../../assets/constants/hospital.contants";
import masterService from "../../../assets/services/master.service";
import HospitalService from "../../../assets/services/hospital.service";
import Expandable from "../../Expandable.vue";
export default {
  components: { Expandable },
  props: {
    value: Object,
    isInternational: Boolean,
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      rules: FIELD,
      pincode: PINCODE,
      form: {},
      citys: [],
      states: [],
      taluks: [],
    };
  },
  computed: {
    types() {
      return HOSPITAL_TYPES;
    },
    master() {
      return this.$store.getters.master;
    },
    isKarnataka() {
      return this.form.state == "29";
    },
    countries() {
      if (this.master.country instanceof Array == false) return [];
      return this.master.country.map((item) => {
        return { value: item.id, name: item.name };
      });
    },
    years() {
      let year = 1899;
      let list = [];
      while (year < new Date().getFullYear()) {
        year++;
        list.push(year);
      }
      return list.reverse();
    },
  },
  watch: {
    isInternational(val) {
      this.form.country = ""
      this.form.state = ""
      this.form.city = ""
      this.form.taluk = ""
      if(!val) {
        // Indian nationality - default to India/Karnataka
        this.form.country = 99
        this.form.state = 29
      }
      this.onCountryChange(true);
      this.onStateChange(true);
    },
  },
  methods: {
    getMaxRules(max) {
      return getMaxRules(max);
    },
    getMaxNotRules(max) {
      return getMaxNotRules(max);
    },
    async onCountryChange(copy) {
      const vm = this;
      if (copy == undefined) {
        vm.form.state = "";
        vm.form.city = "";
      }

      vm.states = [];
      vm.citys = [];
      vm.$emit("input", vm.form);
      if (!vm.form.country) return;
      try {
        vm.$loader.show();
        let { data } = await masterService.getStateCity({
          country_id: vm.form.country,
        });
        let { list, status, msg } = data;
        if (status) {
          vm.states = list.map((item) => {
            return { name: item.name, value: item.id };
          });
        } else {
          vm.$alert.show(msg);
        }
        vm.$loader.hide();
      } catch (error) {
        vm.$loader.hide();
      }
    },
    async onStateChange(copy) {
      const vm = this;
      if (copy == undefined) {
        vm.form.city = "";
      }
      vm.citys = [];
      if (!vm.form.state) return;
      vm.$emit("input", vm.form);
      try {
        vm.$loader.show();
        let { data } = await masterService.getStateCity({
          state_id: vm.form.state,
        });
        let { list, status, msg } = data;
        if (status) {
          vm.citys = list.map((item) => {
            return { name: item.name, value: item.id };
          });
        } else {
          vm.$alert.show(msg);
        }
        vm.$loader.hide();
      } catch (error) {
        vm.$loader.hide();
      }
    },
    async onCityChange(copy) {
      const vm = this;
      if (copy == undefined) {
        vm.form.taluk = "";
      }
      vm.taluks = [];
      vm.$emit("input", vm.form);
      if (!vm.form.city || !vm.isKarnataka) return;
      try {
        let { data } = await HospitalService.getTaluksByDistrict(vm.form.city);
        if (data.status && data.list) {
          vm.taluks = data.list.map((item) => {
            return { name: item.taluk_name, value: item.taluk_id };
          });
        }
      } catch (error) {
        // silent
      }
    },
    input() {
      this.$emit("input", this.form);
    },
  },
  beforeMount() {
    this.form = this.value;
    this.onCountryChange(true);
    this.onStateChange(true);
    this.onCityChange(true);
  },
  mounted() {
    this.input();
  },
};
</script>

<style></style>
